import { render, staticRenderFns } from "./CertificatePersonSelectbox.vue?vue&type=template&id=7dc597d8"
import script from "./CertificatePersonSelectbox.vue?vue&type=script&lang=js"
export * from "./CertificatePersonSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports